import { render, staticRenderFns } from "./MeusCafezinhos.vue?vue&type=template&id=21e18c19&scoped=true"
import script from "./MeusCafezinhos.vue?vue&type=script&lang=js"
export * from "./MeusCafezinhos.vue?vue&type=script&lang=js"
import style0 from "./MeusCafezinhos.vue?vue&type=style&index=0&id=21e18c19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e18c19",
  null
  
)

export default component.exports